module.exports = {
  changeEmail: 'Ja, ändern',
  dontChangeEmail: 'Nein, behalten',
  yes: 'Ja',
  no: 'Nein',
  'next-step': 'Weiter',
  'next-step-wizard': 'Fortzetzen',
  step: 'Schritt',
  off: 'aus',
  'first-step-wizard': 'Ja, wir können beginnen',
  'last-step': 'Jetzt Angebote einholen',
  'go-back': 'Zurück',
  'go-back-wizard': 'Vorheriger Schritt',
  understood: 'Alles klar!',
  'company-placeholder': 'Name des Unternehmens',
  'company-label': 'Firma',
  'address-placeholder': 'Musterstraße 1',
  'company-autocomplete-label': '',
  address_no_number_placeholder: 'Musterstraße',
  'address-label': 'Adresse',
  'address-street-number-label': 'Hausnr.',
  'address-street-number-placeholder': '12',
  'address-no-street-number-label': 'Die Adresse hat keine Nummer',
  'address-not-found': 'Ich kann meine Adresse nicht finden',
  'address-no-match': 'Keine Treffer',
  'address-choose-from': 'Wählen Sie aus mehreren Adressen',
  'address-invalid': 'Die Adresse ist ungültig',
  'address-missing-street-number': 'Fehlende Hausnummer',
  address_alert: 'Haben Sie die richtige Adresse eingegeben?',
  address_missing_city: 'Fehlende Stadt',
  'zip-label': 'PLZ',
  'zip-does-not-exist': 'Postleitzahl existiert nicht',
  zip_placeholder: '12345',
  'name-label': 'Ihr Name',
  'date-format': 'ttmmjj',
  'date-label': 'Datum (6 Ziffern)',
  'birthdate-label': 'Geburtsdatum (6 Ziffern)',
  'national-identity-label': 'Ditt fødselsnummer',
  'national-identity-placeholder': '11 siffer',
  'national-identity-invalid': 'Ikke gyldig fødselsnummer',
  'national-identity-identical':
    'Medlånetakers fødselsnummer kan ikke være identisk med hovedsøkers',
  'bank-account-label': 'Kontonummer',
  'measuring-id-invalid': 'Ikke gyldig målepunkt id',
  'bank-account-placeholder': '11 Ziffern',
  'bank-account-invalid': 'Kontonummer ist ungültig',
  'organization-identity-label': 'Registernummer',
  'organization-identity-placeholder': '9 Ziffern',
  'organization-identity-invalid': 'Registernummer ist ungültig',
  'date-invalid': 'Datum ist ungültig',
  'name-placeholder': 'Max Mustermann',
  'name-invalid': 'Name ist ungültig',
  'email-alert-message': 'Ist die E-mail Adresse korrekt?',
  'email-label': 'E-mail Adresse',
  'email-placeholder': 'max@mustermann.de',
  'email-does-not-exist': 'E-mail Adresse existiert nicht',
  'email-invalid': 'Bitte geben Sie eine gültige E-mail Adresse an',
  email_did_you_mean: 'Meinten Sie',
  'fetching-information': 'Informationen werden abgerufen',
  'comment-label': 'Ergänzende Informationen',
  'comment-placeholder': 'Spezielle Wünsche oder Bedürfnisse.',
  'phone-alert-message': 'Haben Sie die richtige Nummer eingegeben?',
  'phone-label': 'Telefon',
  'phone-invalid': 'Telefonnummer ist ungültig',
  'phone-must-begin-with-+': 'Muss mit + beginnen',
  'phone-foreign': 'Ausländische Telefonnummer',
  'phone-placeholder': '0111 123456',
  'phone-foreign-placeholder-prefix': '+49 ',
  'error-x-numbers': 'Muss --x-- Ziffern sein',
  'error-x-letters': 'Muss --x-- Buchstaben sein',
  'error-min-x-letters': 'Muss mindestens --x-- Buchstaben haben',
  'error-min-x-numbers': 'Muss mindestens --x-- Ziffern sein',
  'error-max-x-numbers': 'Darf maximal --x-- Stellen enthalten',
  'error-inbetween-numbers': 'Muss zwischen --x------y Ziffern haben',
  'error-must-consist-of-x-letters': 'Muss mindestens --x-- Buchstaben enthalten',
  'error-mandatory': 'Pflichtfeld',
  'error-choose': 'Pflichtfeld',
  'error-min-age': 'Tilbud gis dessverre kun til kunder over --x-- år',
  'error-must-accept': 'Muss akzeptiert werden',
  'error-only-digits': 'Kun tall',
  privacy:
    'Ihre Privatsphäre ist geschützt. Wir verarbeiten alle Daten gemäß der Datenschutz-Grundverordnung (DSGVO).',
  close: 'Schließen',
  error_radio_button: 'Må velge et felt',
  invalid_day: 'Ikke gyldig dato',
  invalid_day_in_month: 'Denne datoen finnes ikke i denne måneden',
  invalid_month: 'Monat ist ungültig',
  invalid_year: 'Jahr ist ungültig',
  label_birthdate: 'Geburtsdatum',
  label_date: 'Datum',
  label_month: 'Monat',
  label_year: 'Jahr',
  locale: 'de-DE',
  missing_date: 'Mangler dato',
  missing_month: 'Mangler måned',
  missing_year: 'Mangler år',
  'datepicker-button': 'Velg dato',
  email_wrong_user_account: 'Er du sikker på at e-post brukerkonto er skrevet korrekt?',
  email_wrong_email_address: 'Er du sikker på at du har skrevet en gyldig e-post adresse?',
  not_valid_municipality: 'Ikke gyldig kommune',
  not_valid_state: '',
  'sms-verification-label': 'SMS-Bestätigung',
  'sms-verification-tinyLabel':
    'Bitte tragen Sie hier den Code ein, den wir Ihnen gerade per SMS auf Ihre Mobilfunknummer --xx-- zugesendet haben',
  'sms-verification-error-message': 'Falscher Code',
  'sms-verification-code-not-received-first': 'Sie haben keinen Code erhalten? Klicken ',
  'sms-verification-code-not-received-link': 'Sie hier',
  'sms-verification-code-not-received-last': ', um einen neuen anzufordern.',
  'sms-verification-code-is-sent-again': 'Der Code wurde erneut gesendet.',
  'sms-verification-code-retry-error':
    'Zu viele Anfragen: Bitte warten Sie 30 Sekunden, bevor Sie es nochmal versuchen.',
  'leazard-two-factor-header': 'Fast geschafft',
  'leazard-two-factor-help-text':
    'Wir haben Ihnen einen Code per SMS von +47 59 44 45 00 zugesendet, um Ihre Nummer zu verifizieren. Sie erhalten keine weiteren Textnachrichten von +47 59 44 45 00.',
  'leazard-two-factor-submit': 'Bestätigen',
  'leazard-two-factor-label': 'Geben Sie den Code zur Bestätigung ein.',
  'leazard-loading-text': 'Datenverarbeitung',
  'recaptcha-disclaimer': 'Diese Website ist durch reCAPTCHA geschützt.',
};
